function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.76224 0.756263C6.22882 1.81529 5.82126 2.93085 5.54492 4.08089C6.21567 4.23093 6.90177 4.31998 7.59544 4.34526V0.65918C7.31423 0.675328 7.03613 0.707708 6.76224 0.756263Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6441 4.89062C9.91643 5.05271 9.17357 5.14694 8.422 5.17222V7.28849H10.8951C10.8736 6.48112 10.7896 5.67934 10.6441 4.89062Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.2551 0.756235C8.98129 0.707708 8.70324 0.675328 8.42212 0.65918V4.34504C9.11565 4.32003 9.80095 4.23192 10.4723 4.08188C10.1959 2.93132 9.78805 1.8148 9.2551 0.756235Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42212 11.0591V14.7449C8.70338 14.7288 8.98154 14.6964 9.25546 14.6478C9.77405 13.6191 10.1905 12.5065 10.4746 11.3227C9.80252 11.1724 9.11645 11.0841 8.42212 11.0591Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7223 8.11523C11.7003 8.99234 11.6085 9.86414 11.4479 10.721C12.2699 10.965 13.0607 11.2951 13.816 11.7103C14.5496 10.6523 14.9766 9.41715 15.0513 8.11523H11.7223Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.54309 11.3227C5.81024 12.4358 6.21065 13.5536 6.76223 14.6478C7.03615 14.6964 7.31433 14.7288 7.59557 14.7449V11.0591C6.90127 11.0841 6.21516 11.1724 5.54309 11.3227Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.37337 4.88965C5.22809 5.67801 5.14377 6.47976 5.12231 7.28834H7.59542V5.17248C6.84376 5.14698 6.10022 5.05163 5.37337 4.88965Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M2.2015 3.69336C1.46794 4.75132 1.04093 5.98655 0.966187 7.28849H4.29529C4.31744 6.40951 4.40998 5.53799 4.57097 4.68174C3.75015 4.43844 2.95591 4.1078 2.2015 3.69336Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.74293 11.5327C4.05462 11.7413 3.38101 12.0162 2.71887 12.3697C3.51983 13.275 4.53977 13.9748 5.71736 14.3778C5.30485 13.4615 4.97861 12.51 4.74293 11.5327Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M2.71936 3.03414C3.36714 3.37978 4.04559 3.65964 4.74509 3.87128C4.98075 2.89508 5.30655 1.94265 5.71895 1.02588C4.59184 1.41141 3.55682 2.08771 2.71936 3.03414Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M4.29516 8.11523H0.966187C1.04093 9.41715 1.46792 10.6523 2.20145 11.7103C2.95599 11.2955 3.74669 10.9653 4.56962 10.721C4.40899 9.86414 4.31716 8.99234 4.29516 8.11523Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2985 1.02588C10.7105 1.94257 11.0363 2.89571 11.272 3.87224C11.9758 3.65915 12.649 3.38127 13.2985 3.03447C12.4954 2.12681 11.4742 1.42799 10.2985 1.02588Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M5.12207 8.11523C5.14336 8.9223 5.22705 9.72444 5.37197 10.5134C6.10008 10.3511 6.84332 10.2568 7.59537 10.2315V8.11523H5.12207Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8161 3.69336C13.0764 4.09993 12.2865 4.43385 11.4462 4.68309C11.6073 5.53965 11.7 6.41092 11.7222 7.28841H15.0513C14.9766 5.98649 14.5496 4.75132 13.8161 3.69336Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42212 8.11523V10.2315C9.17414 10.2568 9.9174 10.3511 10.6455 10.5134C10.7904 9.72444 10.8741 8.9223 10.8954 8.11523H8.42212Z"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2104,
  cy: 14.6544,
  r: 5.9371,
  fill: "#F1F2F5"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2169 16.6304V15.7778L14.8552 14.058C15.0628 13.8306 15.2111 13.6329 15.3 13.4649C15.3939 13.2919 15.4409 13.119 15.4409 12.946C15.4409 12.5012 15.1666 12.2788 14.618 12.2788C14.4055 12.2788 14.193 12.3208 13.9805 12.4048C13.768 12.4839 13.5604 12.6074 13.3578 12.7755L12.9871 11.9304C13.2046 11.7426 13.4714 11.5943 13.7877 11.4856C14.109 11.3768 14.4376 11.3225 14.7737 11.3225C15.3569 11.3225 15.8017 11.4535 16.1081 11.7154C16.4194 11.9724 16.5751 12.3406 16.5751 12.82C16.5751 13.1363 16.501 13.4402 16.3527 13.7318C16.2094 14.0184 15.9722 14.3298 15.641 14.6659L14.6328 15.6889H16.7679V16.6304H13.2169Z",
  fill: "#23244D",
  fillOpacity: 0.5
});

var SvgTimezone2Icon = function SvgTimezone2Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimezone2Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timezone-2-icon.069adb59.svg";
export { ForwardRef as ReactComponent };